<template>
  <v-container fluid class="text-center pt-0" style="background-color: #f5f5f5">
    <v-row class="sticky">
      <v-col cols="12" class="px-7 py-5">
        <SurveySearchField
          :initial-value="preSearchedAddress"
          placeholder="Search offers by address, city, or zipcode"
          @survey-search-field-changed="handleSurveySearchFieldChanged"
        />
      </v-col>
    </v-row>

    <v-row style="background-color: #f5f5f5">
      <v-col cols="12">
        <h1 class="grey--text text--darken-4 font-weight-bold">Get amazing deals</h1>
        <h4 class="mb-2 primary--text font-weight-regular">when you share your experience</h4>
      </v-col>
    </v-row>
    <img :src="require('@/assets/survey/sky.png')" class="ma-auto test" />
    <v-img :src="require('@/assets/survey/buildings.png')" :eager="true" max-width="360" class="ma-auto mt-6" />

    <v-row class="mt-0" style="background-color: white; position: relative">
      <v-col cols="12">
        <OfferList
          class="mt-4"
          @offer-list-city-quick-link-clicked="handleCityQuickLinkClicked"
          @offer-list-web-quick-link-clicked="handleWebQuickLinkClicked"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

import { Storage, Constants } from '@/services'

import OfferList from '@/components/OfferList.vue'
import SurveySearchField from '@/components/SurveySearchField.vue'

export default Vue.extend({
  name: 'Offers',

  metaInfo: {
    title: 'Offers',
  },

  components: {
    OfferList,
    SurveySearchField,
  },

  data: () => ({
    preSearchedAddress: null,
  }),

  computed: {
    ...mapGetters('offers', ['scrollPosition']),
  },

  beforeMount: function () {
    if (this.$router.currentRoute.query.address) {
      Storage.setItem(Constants.OFFER_FILTER_ADDRESS, this.$router.currentRoute.query.address)
      this.preSearchedAddress = this.$router.currentRoute.query.address
    } else {
      if (this.$router.currentRoute.query.address === '') {
        Storage.removeItem(Constants.OFFER_FILTER_ADDRESS)
        this.preSearchedAddress = null
      } else {
        if (Storage.getItem(Constants.OFFER_FILTER_ADDRESS)) {
          this.preSearchedAddress = Storage.getItem(Constants.OFFER_FILTER_ADDRESS)
        }
      }
    }
  },

  mounted: function () {
    if (!this.preSearchedAddress) {
      Storage.removeItem(Constants.OFFER_FILTER_ADDRESS)
      this.getOffers()
    }
  },

  methods: {
    ...mapGetters('auth', ['loggedIn']),
    ...mapActions('offers', ['fetchOffers', 'setSearchLatitude', 'setSearchLongitude']),
    getOffers() {
      if (this.scrollPosition > 0) return

      this.fetchOffers()
    },
    updateBrowserHistory(address) {
      if (address) {
        Storage.setItem(Constants.OFFER_FILTER_ADDRESS, address)
        window.history.pushState('', `Offers | ${address} | Localfluence`, `?address=${encodeURIComponent(address)}`)
      } else {
        Storage.removeItem(Constants.OFFER_FILTER_ADDRESS)
        window.history.pushState('', 'Offers | Localfluence', '/')
      }
    },
    handleSurveySearchFieldChanged(result) {
      this.setSearchLatitude(result.latitude)
      this.setSearchLongitude(result.longitude)
      this.updateBrowserHistory(result.address)
      this.fetchOffers(true)
    },
    handleCityQuickLinkClicked(quickLink) {
      const address = `${quickLink.city}, ${quickLink.state}`
      this.preSearchedAddress = address
      this.handleSurveySearchFieldChanged({ address, latitude: quickLink.latitude, longitude: quickLink.longitude })
    },
    handleWebQuickLinkClicked() {
      this.preSearchedAddress = ''
      this.handleSurveySearchFieldChanged({ address: null, latitude: null, longitude: null })
    },
  },
})
</script>

<style scoped>
.sticky {
  position: sticky;
  top: 48px;
  z-index: 2;
  background-color: #f5f5f5;
}

.test {
  left: 50%;
  z-index: 0;
  transform: translateX(-50%);
  position: fixed;
}
</style>
